import type { IconType } from 'react-icons';

export enum CategoryKey {
  BestSellers = 'BEST_SELLERS',
  MensClothing = 'MENS_CLOTHING',
  WomensClothing = 'WOMENS_CLOTHING',
  KidsClothing = 'KIDS_CLOTHING',
  Hats = 'HATS',
  Accessories = 'ACCESSORIES',
}

export type Category = {
  id: string;
  icon: IconType;
};
